import { Request } from '../../../ts/ServerApi/requests/Request';

export interface IUpdateLastSeenUserNotificationRequestParams {
  // TODO finalize params
  lastSeenUserNotificationId: string;
}

export class UpdateLastSeenUserNotificationRequest extends Request<IUpdateLastSeenUserNotificationRequestParams, {}> {
  constructor(params: IUpdateLastSeenUserNotificationRequestParams) {
    //TODO call the correct APIs
    super('updateLastSeenUserNotification', params);
  }
}
